import { createRoot } from 'react-dom/client';
import { getLinkParameters, FORM_IDS } from './getFormParameters';
const getFormIdFromUrl = (url: URL) => parseInt(url.pathname.split('/').pop() || '', 10);
const isFormAssemblyUrl = (url: URL) => url.hostname.includes('tfaforms.net') && FORM_IDS.includes(getFormIdFromUrl(url));
const handleFormAssemblyLinks = (domContainer: HTMLElement) => {
  const links = Array.from(domContainer.getElementsByTagName('a'));
  if (!links.length) {
    return;
  }
  links.map(linkElement => [new URL(linkElement.href), linkElement] as [URL, HTMLAnchorElement]).filter(([url]) => isFormAssemblyUrl(url)).forEach(([url, linkElement]) => {
    const formId = getFormIdFromUrl(url);
    const params = getLinkParameters(formId, domContainer.dataset);

    /* istanbul ignore next */
    if (!params) {
      return;
    }
    const queryString = new URLSearchParams(params).toString();
    const newUrl = `${url.toString()}?${queryString}`;
    const rootContainer = document.createElement('span');
    linkElement.parentNode?.replaceChild(rootContainer, linkElement);
    const root = createRoot(rootContainer);
    root.render(<a href={newUrl} target="_blank" rel="noopener noreferrer">
          {linkElement.textContent}
        </a>);
  });
};
export default handleFormAssemblyLinks;